import { filter, skip, Subscription } from 'rxjs';
import { MessageBusListener } from '../global';
import { generateUniqueId } from '../helper/utility.service';
import { BusService } from '../services/bus.service';

const listenerSubs: SubObjectKey = {};
const listenerCtx: CtxObjectKey = {};
let bus: BusService | null;


/**
 * Décorateur qui écoute les messages envoyés via le bus de service.  
 * Ce décorateur doit être utilisé dans les composants et placé avant le décorateur du composant.
 *  
 * Le décorateur étend la méthode ngOnInit pour capturer le contexte de la classe.  
 * Le bus de service est capturé à partir de la classe, ce qui signifie qu'il doit exister dans le constructeur de la classe source.  
 * Une extension de la méthode ngOnDestroy est utilisée pour libérer les abonnements et prévenir les fuites de mémoire.
 *  
 *  
 * @param listener Nom de l'écouteur, seuls les messages envoyés à cet écouteur seront capturés.  
 * @returns  
 */
export function BusListener(listener: MessageBusListener): any {
    return function (target: any) {
        const originalOnInit = target.prototype.ngOnInit;
        const originalOnDestroy = target.prototype.ngOnDestroy;
        target.prototype.ngOnInit = function() {
            const id = generateUniqueId();
            //console.log('id: ' + id + ' - name: ' + this.constructor?.name); //debug
            this.__id = id;
            listenerCtx[id] = this;
            getServiceBus(id)
            startListener(id, listener);
            if (originalOnInit) {
                originalOnInit.call(this);
            }
        }
        target.prototype.ngOnDestroy = function() {
            const id = this.__id;
            if (listenerSubs[id]) {
                   listenerSubs[id].unsubscribe();
                delete listenerSubs[id];
                delete listenerCtx[id];
            };
            if (originalOnDestroy) {
                originalOnDestroy.call(this);
            }
        }
    }
}

export function getServiceBus(id: string) {
    const ctx = listenerCtx[id];
    if (ctx && !bus) {
        for (const prop in ctx) {
            if (ctx[prop] instanceof BusService) {
                bus = ctx[prop];
            }
        }
    }
}

export function  startListener(id: string, listener: MessageBusListener) {
    const ctx = listenerCtx[id];
    if (bus && ctx) {
        const sub = new Subscription();
        sub.add(bus.messages$().pipe(skip(1),filter((x: any) => x.listener === listener || x.listener === MessageBusListener.All)).subscribe((resp: any) => {
            const actionName = resp?.actionName;
            if (actionName) {
                if (typeof ctx[actionName] === 'function') {
                    ctx[actionName].call(ctx, resp.data, resp.dialogId);
                }
            }
        }));
        listenerSubs[id] = sub;
    }
}

export interface SubObjectKey {
    [key: string]: Subscription;
}
export interface CtxObjectKey {
    [key: string]: any;
}